import api from 'api'
import useSWR from 'swr'

/**
 * カスタムプロパティを取得するSWR
 * @param owner_id プロパティを表示するオーナーのID
 * @param {Property["object_type"]}object_type 特定のプロパティを取得するときに渡す
 */
export const useProperties = (
  owner_id?: string,
  object_type?: Property['object_type'],
) => {
  const keys = ['/static/properties', owner_id, object_type]
  return useSWR<Property[]>(
    keys,
    (path) =>
      api
        .get(path, {
          params: {
            owner_id: owner_id,
            object_type: object_type,
          },
        })
        .then((res) => res.data),
    {
      revalidateOnFocus: false,
    },
  )
}
